import { ChevronLeft, ChevronRight } from "lucide-react";

export const PER_PAGE = 20;

export const Pager = ({ page, perPage = PER_PAGE, total, onPage, testId }) => {
  const pages = Math.max(1, Math.ceil(total / perPage));
  if (total <= perPage) return null;
  const from = (page - 1) * perPage + 1;
  const to = Math.min(total, page * perPage);
  const step = (next) => onPage(Math.min(pages, Math.max(1, next)));
  const arrow =
    "flex h-8 w-8 items-center justify-center border border-slate-200 text-slate-500 transition-colors duration-150 hover:border-slate-900 hover:text-slate-900 disabled:cursor-not-allowed disabled:opacity-40";

  return (
    <div
      className="flex flex-col items-center justify-between gap-3 border-t border-slate-200 pt-5 sm:flex-row"
      data-testid={testId}
    >
      <p className="text-[11px] uppercase tracking-[0.14em] text-slate-500" data-testid={`${testId}-range`}>
        Showing {from}&ndash;{to} of {total} · most recent first
      </p>
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={() => step(page - 1)}
          disabled={page <= 1}
          data-testid={`${testId}-prev`}
          className={arrow}
        >
          <ChevronLeft className="h-4 w-4" strokeWidth={1.8} />
        </button>
        <span className="num text-[12px] text-slate-600" data-testid={`${testId}-page`}>
          Page {page} of {pages}
        </span>
        <button
          type="button"
          onClick={() => step(page + 1)}
          disabled={page >= pages}
          data-testid={`${testId}-next`}
          className={arrow}
        >
          <ChevronRight className="h-4 w-4" strokeWidth={1.8} />
        </button>
      </div>
    </div>
  );
};
